module.exports = __webpack_public_path__ + "static/assets/2749135d1e1acdf894f44b8fd887e7e5.png";